import React from 'react';
import { onClickBtnStartTrackingCOGS } from 'actions/library/item';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { Link } from 'react-router';
import WarningLabel from '../../WarningLabel';
import COGSField from './COGSField';

class COGSFieldArray extends React.Component {
  render() {
    const { fields, disabled, classButton } = this.props;
    let isTrack = false;
    let isTrackCOGS = false;
    const COGS = [];
    fields.forEach((member, index, fields) => {
      const fieldValues = fields.get(index);
      if (fieldValues.track_cogs) {
        isTrackCOGS = true;
      }
      if (fieldValues.track_stock) {
        isTrack = true;
      }
      if (
        (fieldValues.track_stock && fieldValues.track_cogs) ||
        (fieldValues.is_recipe && fieldValues.has_cogs === true)
      ) {
        COGS.push(
          <COGSField
            member={member}
            key={index}
            isSaved={fieldValues.saved_cogs}
          />
        );
      }
    });
    return (
      <div>
        <div className="row">
          {COGS.length > 0 && (
            <span
              className={`col-sm-offset-8 col-sm-4 text-left pl-0px label-instock`}
            >
              AVG COST
            </span>
          )}
          {COGS}
          {!disabled && (
            <div className="form-group col-sm-12">
              <button
                onClick={e => {
                  this._onClickStartTracking(e, isTrackCOGS);
                }}
                className={`btn btn-primary btn-block no-border-radius-top ${
                  !isTrack ? classButton : ''
                }`}
                disabled={!isTrack}
              >
                {!isTrackCOGS
                  ? 'Start Tracking Cost of Goods Sold (COGS)'
                  : 'Manage Cost of Goods Sold (COGS)'}
              </button>
            </div>
          )}
        </div>
        {!disabled && isTrack && (
          <WarningLabel
            content="Avg cost can not be changed after saving the item, so please make sure that is correct!"
            type="info"
          />
        )}
        {disabled && (
          <WarningLabel type="warning" link recepie>
            This item is associated with ingredients. Use the{' '}
            <Link to="/ingredient/recipes">
              <i>Ingredient Page</i>
            </Link>{' '}
            to manage Cost of Goods Sold (COGS).
          </WarningLabel>
        )}
        {!disabled && !isTrack && (
          <WarningLabel
            content="This item can not be tracked because the inventory stock is not tracked."
            type="warning"
          />
        )}
      </div>
    );
  }

  _onClickStartTracking = (e, isTrack) => {
    const { dispatch, itemForm } = this.props;
    dispatch(onClickBtnStartTrackingCOGS(itemForm, isTrack));
    e.stopPropagation();
    e.preventDefault();
  };
}

function mapStateToProps(state) {
  return {
    itemForm: getFormValues('item')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(COGSFieldArray);
